import type { Service } from "../../types";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import styles from "./Services.module.css";

export function ServiceCard({ service, delay = 0 }: { service: Service; delay?: number }) {
  const ref = useScrollReveal<HTMLDivElement>();
  const { Icon } = service;

  return (
    <article
      ref={ref}
      className={`${styles.card} reveal`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className={styles.iconRow}>
        <Icon className={styles.icon} />
        <span className={styles.number} aria-hidden="true">
          {service.number}
        </span>
      </div>
      <h3>{service.title}</h3>
      <p>{service.description}</p>
    </article>
  );
}
